import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from '../Stateless/SnackBarProvider';
import { useLoginApi } from '../../hooks/useLoginApi';

export const CreateLogin = () => {
  //   const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { createLogin } = useLoginApi();
  return useMutation({
    mutationKey: ['CreateChoice'],
    mutationFn: (data: any) => createLogin(data),
    onSuccess: (response: any) => {
      showMessage(response?.message || 'Loged In successfully', 'success');
      //   queryClient.invalidateQueries({
      //     queryKey: ['getChoices'],
      //     exact: false,
      //   });
    },
    onError: (error: any) => {
      showMessage(error.response?.data?.message || 'Failed to login', 'error');
    },
  });
};
